import { Components } from '@mui/material';
import { grey } from '@mui/material/colors';
import { typography } from '../typography';

export const getMuiToggleButton = (): Components['MuiToggleButton'] => ({
  styleOverrides: {
    root: {
      backgroundColor: `${grey[300]} !important`,
      borderColor: `${grey[300]} !important`,
      fontWeight: typography.fontWeightRegular,
      color: grey[900],
      '&.MuiToggleButton-root.Mui-selected': {
        backgroundColor: '#FBC02D !important',
        borderColor: '#FBC02D !important',
        color: grey[900],
        fontWeight: typography.fontWeightBold,
      },
    },
  },
});
